
import AppHeader from '@/components/Header.vue'
import { defineComponent, ref, getCurrentInstance, onMounted, computed } from 'vue'
import { useStore } from 'vuex'
export default defineComponent({
  components: {
    AppHeader,
  },
  setup() {
    const title = ref('')
    const url = ref('')
    const { proxy } = getCurrentInstance()
    const store = useStore() // vuestore
    const pagePaddingTop = computed(() => store.getters.pagePaddingTop)
    onMounted(() => {
      title.value = proxy.$route.query.title as string
      url.value = proxy.$route.query.url as string
      const el = document.getElementById('my-iframe') as HTMLIFrameElement
      console.log('el.contentWindow.document.title', el.contentWindow.document.title)
    })
    return {
      title,
      url,
      pagePaddingTop,
    }
  },
})
